import { RcLoggerService } from '../../../remote-control-ng/services/rcLoggerService';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';
import { IInitRequestPacket, SignatureByte } from 'app/modules/remote-control-ng/definitions';

export interface WebInitResponse {
    returnCode: number;
    versionHigh: number;
    versionLow: number;
    hasScreenInfo: boolean;
    width: number;
    height: number;
    rotation: number;
    hasModelInfo: boolean;
    model: string;
    osType: number;
    permissions: number;
}

export class StartRemoteControlMessage extends BaseMessage {
    public request: IInitRequestPacket;
    static RemoteControlStartMessageId = 100;

    public response?: WebInitResponse;
    private log: RcLoggerService;

    constructor(
        options: IInitRequestPacket,
        sig?: number) {
        super();
        this.header.sig = sig ? sig : SignatureByte.SignatureCommMessage;
        this.header.command = StartRemoteControlMessage.RemoteControlStartMessageId;
        this.request = options;
    }

    public serializeBody(buffer: MemoryBuffer): void {
        console.log(
            'Creating PC_INIT - deviceId:' + this.request.deviceId
            + ' sotiAssistDeviceId:' + this.request.sotiAssistDeviceId
            + ' userName:' + this.request.userName
            + ' token:' + (this.request.token ? this.request.token.substr(0, 8) : '') + '...'
            + ' sessionId:' + (this.request.sessionId ? this.request.sessionId.substr(0, 10) : '') + '...'
            + ' keys: ' + (this.request.keys ? this.request.keys.substr(0, 50) : '') + '...'
            + ' versionHi:' + this.request.versionHigh
            + ' versionLo:' + this.request.versionLow
            + ' disableUserDisplay:' + this.request.disableUserDisplay
            + ' disableUserInteraction:' + this.request.disableUserInteraction
            + ' forceOverride:' + this.request.forceOverride);

        buffer.writeStringLE(this.request.deviceId);
        // There are two type of protocol (using signature to distinguish), for the 0xD8, we do not send SotiAssistDeviceId, otherwise, we send it
        if (this.header.sig === SignatureByte.SignatureCommMessage) {
            buffer.writeStringLE(this.request.sotiAssistDeviceId);
        }
        buffer.writeStringLE(this.request.userName);
        buffer.writeStringLE(this.request.token);
        buffer.writeStringLE(this.request.sessionId);
        buffer.writeStringLE(this.request.keys);
        buffer.writeStringLE(this.request.host);
        buffer.writeUInt8(this.request.versionHigh);
        buffer.writeUInt8(this.request.versionLow);
        buffer.writeUInt8(Number(this.request.forceOverride));
        if (this.request.disableUserDisplay || this.request.disableUserInteraction) {
            buffer.writeUInt8(Number(this.request.disableUserDisplay || false));
            buffer.writeUInt8(Number(this.request.disableUserInteraction || false));
        }
    }
}
